import { render, staticRenderFns } from "./clueData.vue?vue&type=template&id=aa8a833a&scoped=true"
import script from "./clueData.vue?vue&type=script&lang=js"
export * from "./clueData.vue?vue&type=script&lang=js"
import style0 from "./clueData.vue?vue&type=style&index=0&id=aa8a833a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8a833a",
  null
  
)

export default component.exports